import * as React from 'react';
const ListContext = /*#__PURE__*/React.createContext(null);
export default ListContext;